import { Box, Button, Container } from '@mui/material';
import HeaderBreadcrumbs from 'src/components/header-bread-crumbs/HeaderBreadcrumbs';
import Page from 'src/components/page/page';
import { paths } from 'src/routes/paths';
import CNLoading from 'src/components/loading-cn/CNLoading';
import TableRox from 'src/components/table-rox/TableRox';
import { useMyDataStore } from 'src/store/me/me.store';
import useLPEventsList from './events-lp-list.hook';

export default function LpEventsList() {
  const { TABLEHEADER, isLoadingLpEventsList, lpEventsList, navigate } = useLPEventsList();

  const permissions = useMyDataStore((state) => state.me?.cnAdminInfo?.permissions?.benefits)

  return (
    <Page title="Lista de Eventos LP">
      <Container maxWidth="lg">
        <HeaderBreadcrumbs
          heading="Lista de Eventos LP"
          links={[]}
          action={
            <Button variant="contained" onClick={() => navigate(paths.dashboard.lpEventCreate)} disabled={!permissions?.create}>
              Cadastrar Evento LP
            </Button>
          }
        />
        {isLoadingLpEventsList ? (
          <Box flexGrow={1} display="flex" justifyContent="center" alignItems="center" mt={30}>
            <CNLoading />
          </Box>
        ) : (
          <TableRox
            data={lpEventsList}
            header={TABLEHEADER}
            defaultOrderBy="name"
            hasSearch
            onClickKey="_id"
            onClickFunction={(id) => navigate(paths.dashboard.lpEventDetails(id))}
          />
        )}
      </Container>
    </Page>
  );
}
